module.exports = __webpack_public_path__ + "img/card-product4.e00c5af4.jpg";